module.exports = __webpack_public_path__ + "static/media/caffe-milano-cover.934f4cf0.jpg";